import {useTranslation} from "react-i18next";
import {useState} from "react";
import associateServices from "../../../services";
import {toast} from "react-toastify";
import FormButton from "../../../components/form-button";
import {useSelector} from "react-redux";
import InformationToast from "../../../components/toast/InformationToast";
import axios from "axios";

const INITIAL_STATE = {
    name: '',
    folder: ''
}

const Level4 = () => {

    const {t} = useTranslation()
    const {token} = useSelector(state => state.authenticationReducer)
    const [image, setImage] = useState(INITIAL_STATE);
    const [selectedFile, setSelectedFile] = useState(null);
    const [disabled, setDisabled] = useState(null);
    const [loading, setLoading] = useState(false)

    const handleFileInput = (e) => {
        // handle validations
        const file = e.target.files[0];

        if (!file)
            return toast(<InformationToast
                icon={'ti-x'}
                title={t(`general.error`)}
                message={t(`api-notifications.document-not-uploaded`)}
            />)
        // Use FileReader instead of URL.createObjectURL for better iOS support
        const reader = new FileReader();
        reader.onload = () => {
            setImage({
                folder: reader.result,  // Set the base64 URL for image preview
                name: file.name || 'uploaded-image.jpg'  // Fallback name for iOS
            });
        };

        reader.readAsDataURL(file); // Read file as a base64 encoded URL
        setSelectedFile(file);
    };

    const handleUpload = async () => {
        setLoading(true)
        const formData = new FormData();

        formData.append("type", 'proof-of-address');
        formData.append("name", image.name);
        formData.append("file", selectedFile);


        try {
            const response = await axios.post('https://api1.ebetlab.com/api/player/documents/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': token?.includes('Bearer ') ? token : 'Bearer ' + token,
                },
            });
            setLoading(false)

            console.log('response = ', response)
            if (response?.data?.status !== 200) {
                return toast(<InformationToast
                    icon={'ti-x'}
                    title={t(`general.error`)}
                    message={t(`api-notifications.${response?.data?.errors}`)}
                />)
                // throw new Error(data?.errors || "unknown-error");
            }
            toast(<InformationToast
                icon={'ti-check'}
                title={t(`general.information`)}
                message={t(`api-notifications.${response?.data?.data}`)}
            />)
        } catch (error) {
            console.error('File upload error:', error);
        }
    }


    return (
        <div className="settings">

            <div className="settings__container">
                <div className="row">
                    <div className="col-12">
                        <p className="settings__text">
                            {t('settings.verify.level4.desc')}
                        </p>
                    </div>
                </div>
            </div>
            <div  className="settings__form">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="form__group">
                                    <label htmlFor="" className="form__label">
                                        {t('settings.verify.level4.title')}
                                        <b>*</b>
                                    </label>
                                    <div className="form__img">
                                        <label id="img4" htmlFor="form__img-upload4">
                                            {
                                                image?.name && image?.name
                                            }
                                        </label>
                                        <input
                                            data-name="#img4"
                                            onChange={handleFileInput}
                                            id="form__img-upload4"
                                            name="img4"
                                            type="file"
                                            // capture="environment"
                                            accept=".png, .jpg, .jpeg, .pdf"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <p className="form__note">
                                    {t('settings.verify.level4.accepted')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="settings__actions">
                <p className="settings__note">
                    {t('settings.verify.level4.footer')}
                </p>
                <div className="settings__btns">
                    <FormButton
                        isSmall={true}

                        onClick={handleUpload}
                        label={t('settings.verify.level4.submit')}
                        disabled={disabled || !image.name}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    )
}
export default Level4
